<template>
  <div>
    <div class="md-layout-item wrapper">
      <!--<h5 class="md-toolbar-section-start">{{label | token_replace(nid)}}</h5> -->
      <div class="md-layout-item md-gutter">
        <div
          v-bind:key="index"
          v-for="(option, index) in sections"
          class="md-layout-item likert-item"
        >
          <div class="md-layout-item md-toolbar-section-start">
            <div class="md-layout-item">
              <md-field :class="messageClass" class="label-top">
                <h5 v-if="option.label">{{option.label}}</h5>
              </md-field>

              <vue-slider
                @change="updateValue"
                v-model="value[option.label]"
                :data="optionsSet"
                :marks="true"
                :tooltip-formatter="formatter"
                :tooltip-placement="'bottom'"
                :useKeyboard="true"
                ref="slider"
              >
                <template slot="tooltip" slot-scope="{value}">
                  <div class="vue-slider-dot-tooltip-inner vue-slider-dot-tooltip-inner-bottom" :class="tooltipClass(value)">
                    <span class="vue-slider-dot-tooltip-text">{{ formatter(value) }}</span>
                  </div>
                </template>
              </vue-slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlider from "vue-slider-component";

export default {
  name: "FbLikertView",
  props: ["checkbox", "valid", "validate", "nid"],
  components: {
    VueSlider,
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true,
      };
    },
  },
  mounted() {
    this.$el.addEventListener("mousedown", this.stopMouseEvent);

    // Add tabindex 0 and tabs behavior to slider.
    this.$refs.slider.forEach((slider) => {
      slider.$el.querySelectorAll(".vue-slider-dot").forEach((el) => {
        el.setAttribute("tabindex", 0);
        el.addEventListener("focus", () => {
          if (!slider.getValue() && slider.getIndex() === -1) {
            slider.setIndex(0);
          }
          slider.focus();
        });
        el.addEventListener("blur", () => slider.blur());
        el.addEventListener("mouseenter", () => {
          if (!slider.getValue() && slider.getIndex() === -1) {
            slider.setIndex(0);
          }
        });
      });
    });
  },
  data() {
    let value = {};
    this.checkbox.sections.forEach((k) => {
      value[k.label] = this.checkbox.value[k.label] || "";
    });

    let optionsSet = [];
    this.checkbox.options.forEach((k) => {
      optionsSet.push(k.value);
    });
    let _self = this;
    return {
      label: "",
      options: this.checkbox.options.map((option) => {
        return Object.assign({}, option);
      }),
      sections: this.checkbox.sections.map((option) => {
        return Object.assign({}, option);
      }),
      value: value,
      optionsSet: optionsSet,
      formatter: function (value) {
        let result = "";

        _self.options.forEach((option) => {
          if (option.value == value) {
            result =
              option.tooltip == "" || typeof option.tooltip == "undefined"
                ? value
                : option.tooltip;
          }
        });

        return result;
      },
    };
  },
  methods: {
    stopMouseEvent(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    updateValue() {
      this.$emit("change", this.value);
    },
    tooltipClass(val) {
      if (this.optionsSet.indexOf(val) == 0) {
        return 'firstItem';
      }
      if (this.optionsSet.indexOf(val) == this.optionsSet.length - 1) {
        return 'lastItem';
      }
    },
  },
  watch: {
    checkbox: function (val) {
      this.label = val.label;
      this.options = val.options.map((option) => {
        return Object.assign({}, option);
      });
      this.sections = val.sections.map((option) => {
        return Object.assign({}, option);
      });
    },
  },
};
</script>

<style lang="scss" >
.md-layout-item.wrapper {
  padding-top: 45px;
}

.vue-slider {
  height: 8px !important;
}

.likert-item {
  padding-bottom: 40px;
}
.fb-view-card .md-card.form .likert-item h5 {
  text-align: left;
}

/* component style */
.vue-slider-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* rail style */
.vue-slider-rail {
  background-color: rgb(185, 231, 245) !important;
  border-radius: 15px;
}

/* process style */
.vue-slider-process {
  background-color: rgb(185, 231, 245) !important;
  border-radius: 15px;
}

/* mark style */
.vue-slider-mark {
  z-index: 4;
}
.vue-slider-mark:first-child .vue-slider-mark-step,
.vue-slider-mark:last-child .vue-slider-mark-step {
  display: none;
}
.vue-slider-mark-step {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  //background-color: rgba(0, 0, 0, 0.16);
}
.vue-slider-mark:first-child {
  .vue-slider-mark-label {
    padding-left: 5px;
  }
}
.vue-slider-mark:last-child {
  .vue-slider-mark-label {
    padding-right: 5px;
  }
}
.vue-slider-mark-label {
  font-size: 14px;
  white-space: nowrap;
}
/* dot style */
.vue-slider-dot-handle {
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: $blue-active;
  box-sizing: border-box;
  // box-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32);
}
.vue-slider-dot-handle-focus {
  //box-shadow: 0px 0px 1px 2px rgba(52, 152, 219, 0.36);
}

.vue-slider-dot-handle-disabled {
  cursor: not-allowed;
  background-color: #ccc;
}

.vue-slider-dot-tooltip-inner {
  font-size: 14px;
  padding: 2px 5px;
  min-width: 140px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  border-color: #3498db;
  background-color: #3498db;
  box-sizing: content-box;
  @media (min-width: $breakpoint-small) {
    min-width: 160px;
  }

  &.firstItem {
    position: absolute;
    left: -8px;
    &:after {
      left: 8px;
    }
  }
  &.lastItem {
    position: absolute;
    right: -8px;
    &:after {
      left: calc(100% - 8px);
    }
  }
}
.vue-slider-dot-tooltip-inner::after {
  content: "";
  position: absolute;
}
.vue-slider-dot-tooltip-inner-top::after {
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  height: 0;
  width: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px;
  border-top-color: inherit;
}
.vue-slider-dot-tooltip-inner-bottom::after {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  height: 0;
  width: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px;
  border-bottom-color: inherit;
}
.vue-slider-dot-tooltip-inner-left::after {
  left: 100%;
  top: 50%;
  transform: translate(0, -50%);
  height: 0;
  width: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px;
  border-left-color: inherit;
}
.vue-slider-dot-tooltip-inner-right::after {
  right: 100%;
  top: 50%;
  transform: translate(0, -50%);
  height: 0;
  width: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 5px;
  border-right-color: inherit;
}

.vue-slider-dot-tooltip-wrapper {
  opacity: 0;
  transition: all 0.3s;
}
.vue-slider-dot-tooltip-wrapper-show {
  opacity: 1;
}

/*# sourceMappingURL=default.css.map */
</style>
